import React from 'react';
import {Button} from "primereact/button";
import Paper from "@material-ui/core/Paper";
import LinearProgress from "@material-ui/core/LinearProgress";
import Grid from "@material-ui/core/Grid";
import TitlePage from "../../../app/Title/TitlePage/TitlePageView";
import {amount, price, rate} from "../../../utils/formatters/Numbers";
import {dateDDMMYY} from "../../../utils/formatters/Date";
import NumberFormat from "react-number-format";
import {calculateAmount, calculateReward} from "../../../utils/calculate/Amount";
import SubtitleLabel from "../../../app/Title/SubtitleLabel/SubtitleLabelView";

const OrderPtm = ({
                      isLoading,
                      handleReturnButton,
                      orderPtm,
                      ...props
                  }) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!isLoading}/>
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                {props.messagesGrowl}
                <Grid container spacing={1}>
                    <Grid item xs={6}>
                        <TitlePage title='Ventanilla \ Tomar Postura'/>
                    </Grid>
                    <Grid item xs={6}>
                        <Grid container spacing={2} justify="flex-end">
                            <Grid item>
                                <Button label="Cancelar" onClick={handleReturnButton} className="p-button-secondary"/>
                            </Grid>
                            <Grid item>
                                {props.confMsg}
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <div className="p-grid">
                            <div className="p-col-4">
                                <SubtitleLabel header="Emisora" isBold={true}/>
                                <SubtitleLabel header={orderPtm.emisora}/>
                            </div>
                            <div className="p-col-4">
                                <SubtitleLabel header="Precio" isBold={true}/>
                                <SubtitleLabel header={price(orderPtm.precio)}/>
                            </div>
                            <div className="p-col-4">&nbsp;</div>
                            <div className="p-col-4">
                                <SubtitleLabel header="Títulos" isBold={true}/>
                                <NumberFormat
                                    className={"p-inputtext p-component p-filled"}
                                    name="cantidad"
                                    value={orderPtm.cantidad}
                                    onChange={props.saveDataOrderLender}
                                    thousandSeparator={true}/>
                            </div>
                            <div className="p-col-4">
                                <SubtitleLabel header="Importe" isBold={true}/>
                                <SubtitleLabel header={calculateAmount(orderPtm.precio, orderPtm.cantidad)}/>
                            </div>
                            <div className="p-col-4">&nbsp;</div>
                            <div className="p-col-4">
                                <SubtitleLabel header="Plazo" isBold={true}/>
                                <NumberFormat
                                    className={"p-inputtext p-component p-filled"}
                                    name="plazo"
                                    value={orderPtm.plazo}
                                    onChange={props.saveDataOrderLender}
                                    thousandSeparator={true}/>
                            </div>
                            <div className="p-col-4">
                                <SubtitleLabel header="Fecha Valor" isBold={true}/>
                                <SubtitleLabel header={dateDDMMYY(orderPtm.fecValor)}/>
                            </div>
                            <div className="p-col-4"> &nbsp;</div>
                            <div className="p-col-4">
                                <SubtitleLabel header="Tasa" isBold={true}/>
                                <SubtitleLabel header={rate(orderPtm.tasa)}/>
                            </div>
                            <div className="p-col-4">
                                <SubtitleLabel header="Premio" isBold={true}/>
                                <SubtitleLabel
                                    header={calculateReward(orderPtm.precio, orderPtm.cantidad, orderPtm.tasa, orderPtm.plazo)}/>
                            </div>
                            <div className="p-col-4">
                                <SubtitleLabel header="Premio Mínimo" isBold={true}/>
                                <SubtitleLabel header={amount(orderPtm.premioMin)}/>
                            </div>
                            <div className="p-col-4">
                                <SubtitleLabel header="Sobretasa" isBold={true}/>
                                <SubtitleLabel header={orderPtm.sobreTasa}/>
                            </div>
                            <div className="p-col-4">
                                <SubtitleLabel header="Tipo Aforo" isBold={true}/>
                                <SubtitleLabel header={orderPtm.tipoAforo}/>
                            </div>
                            <div className="p-col-4"> &nbsp;</div>
                        </div>

                        <Grid item xs={12}>
                            <Grid container spacing={2}>
                                <Grid item>
                                    <SubtitleLabel header="Valores Aceptados en Garantía: " isBold={true}/>
                                    <SubtitleLabel header={orderPtm.restricciones}/>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Paper>
        </React.Fragment>
    )
};

export default (OrderPtm);